module.exports = __webpack_public_path__ + "img/3802.32b99cdf.png";